import { Icon } from "components";

interface BadgeProps {
  step?: number;
  text: string;
  title?: string;
  icon: string;
  handleClick?: () => void;
  isLast?: boolean;
}
export const BadgeStep = (props: BadgeProps) => {
  const { title, text, icon, isLast, handleClick } = props;
  return (
    <div className="flex gap-3 items-start text-white-500 justify-start w-full">
      <div className="flex flex-col items-center justify-center">
        <div
          className="bg-primary-700 p-2 rounded-lg text-primary-500"
          onClick={handleClick}
        >
          <Icon name={icon} size={17} />
        </div>
        {!isLast && (
          <div className="flex min-h-[40px] h-full border-r border-dashed border-primary-500 w-1"></div>
        )}
      </div>
      <div className="flex flex-col h-full justify-start gap-1 text-xs">
        <strong className="capitalize">{title}</strong>
        <small className="text-xs text-white-500">{text}</small>
      </div>
    </div>
  );
};
